import { render } from "./WaterBillPayReturn.vue?vue&type=template&id=4025e641&scoped=true"
import script from "./WaterBillPayReturn.vue?vue&type=script&lang=js"
export * from "./WaterBillPayReturn.vue?vue&type=script&lang=js"

import "./WaterBillPayReturn.vue?vue&type=style&index=0&id=4025e641&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4025e641"]])

export default __exports__